export enum StatusIntegrationLogEnum {
  Success = 1,
  Error = 2
}
